import BONESMidwayJavaScriptClient from 'BONESMidwayJavaScriptClient'

export let apiClient

export const init = (props = {}) => {
  new BONESMidwayJavaScriptClient({
    onReady: (client) => {
      apiClient = client
      apiClient.defaults.timeout = 30000
      if (props.onReady) {
        props.onReady()
      }
    }
  })
}

export const getContracts = () => {
    return apiClient.get('contracts').then(response => response.data.contracts)
}

export const getContract = (contractId) => {
    return apiClient.get(`contract?contractId=${contractId}`).then(response => response.data)
}

export const createContract = (contract) => {
    return apiClient.post('contracts', { contract }).then(response => response.data)
}

export const setContractAsCurrent = (contractId) => {
    return apiClient.post('contract/activate', { contractId }).then(response => response.data)
}

export const getSeller = (sellerId) => {
    return apiClient.get(`seller?sellerId=${sellerId}`).then(response => response.data)
}


// WEBPACK FOOTER //
// ./src/common/ApiClient/ApiClient.jsx